import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getaboutAPi, createaboutAPi,  uploadaboutAPi, deleteaboutApi } from "../../../ApiUrl";
import { toast } from "react-toastify";

export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,   
};
// create about
export const createabout = createAsyncThunk('createabout/about', async (formData, { rejectWithValue }) => {
    try {
        const response = await axios.post(createaboutAPi, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updateabout = createAsyncThunk('updateabout/about', async ({selectedId, formData }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${uploadaboutAPi}/${selectedId}`, formData, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get about
export const getabout = createAsyncThunk('getabout/about', async () => {
    try {
        const response = await axios.get(`${getaboutAPi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'abouts' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete about
export const deleteabouts = createAsyncThunk('deleteabouts/about', async (aboutid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${deleteaboutApi}/${aboutid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'aboutid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const aboutSlice = createSlice({
    name: 'about',
    initialState: {
        abouts: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create about
            .addCase(createabout.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createabout.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(createabout.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //update about
            .addCase(updateabout.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateabout.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(state.message);
                }
                state.status = 'idle';

            })
            .addCase(updateabout.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(state.error);
                }
            })
            //getabouts
            .addCase(getabout.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getabout.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.abouts = action.payload;
            })
            .addCase(getabout.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete abouts
            .addCase(deleteabouts.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteabouts.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.abouts.data = state.abouts.data.filter(abouts => abouts.aboutid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deleteabouts.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default aboutSlice.reducer;
